/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Member } from './Member'
import { MemberFromJSON, MemberFromJSONTyped, MemberToJSON } from './Member'

/**
 *
 * @export
 * @interface GetCompanyMembers200Response
 */
export interface GetCompanyMembers200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetCompanyMembers200Response
   */
  status: boolean
  /**
   *
   * @type {Array<Member>}
   * @memberof GetCompanyMembers200Response
   */
  data: Array<Member>
}

/**
 * Check if a given object implements the GetCompanyMembers200Response interface.
 */
export function instanceOfGetCompanyMembers200Response(
  value: object
): value is GetCompanyMembers200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetCompanyMembers200ResponseFromJSON(
  json: any
): GetCompanyMembers200Response {
  return GetCompanyMembers200ResponseFromJSONTyped(json, false)
}

export function GetCompanyMembers200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCompanyMembers200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(MemberFromJSON),
  }
}

export function GetCompanyMembers200ResponseToJSON(
  value?: GetCompanyMembers200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(MemberToJSON),
  }
}
